import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { subclass as s } from "./accessorSupport/decorators/subclass.js";
var t = 0;

var r = function r(_r2) {
  var o = /*#__PURE__*/function (_r) {
    _inherits(o, _r);

    var _super = _createSuper(o);

    function o() {
      var _this;

      _classCallCheck(this, o);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(e)), Object.defineProperty(_assertThisInitialized(_this), "uid", {
        writable: !1,
        configurable: !1,
        value: Date.now().toString(16) + "-object-" + t++
      });
      return _this;
    }

    return o;
  }(_r2);

  return o = e([s("esri.core.Identifiable")], o), o;
};

var o = /*#__PURE__*/function (_r3) {
  _inherits(o, _r3);

  var _super2 = _createSuper(o);

  function o() {
    _classCallCheck(this, o);

    return _super2.apply(this, arguments);
  }

  return o;
}(r( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  return _class;
}()));

o = e([s("esri.core.Identifiable")], o);
export { o as Identifiable, r as IdentifiableMixin };